import React from 'react';
import {asyncComponent} from 'react-async-component';

export const AsyncDestinationInfographic = asyncComponent({
    resolve: () => import(
        /* webpackChunkName: "destination-infographic" */
        /* webpackPreload: true */
        './DestinationInfographic'
    ),
    LoadingComponent: () => <span />,
    serverMode: 'defer'
});
